// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/RatingsBlob/ratingsBlob.scss
// module id = 1413
// module chunks = 10